import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent, classNamesFunction } from '../../Utilities';
import { Icon } from '../../Icon';
import { IconButton } from '../../Button';
var getClassNames = classNamesFunction();
/**
 * {@docCategory DocumentCard}
 */
var DocumentCardActionsBase = /** @class */ (function (_super) {
    tslib_1.__extends(DocumentCardActionsBase, _super);
    function DocumentCardActionsBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentCardActionsBase.prototype.render = function () {
        var _this = this;
        var _a = this.props, actions = _a.actions, views = _a.views, styles = _a.styles, theme = _a.theme, className = _a.className;
        this._classNames = getClassNames(styles, {
            theme: theme,
            className: className
        });
        return (React.createElement("div", { className: this._classNames.root },
            actions &&
                actions.map(function (action, index) {
                    return (React.createElement("div", { className: _this._classNames.action, key: index },
                        React.createElement(IconButton, tslib_1.__assign({}, action))));
                }),
            views > 0 && (React.createElement("div", { className: this._classNames.views },
                React.createElement(Icon, { iconName: "View", className: this._classNames.viewsIcon }),
                views))));
    };
    return DocumentCardActionsBase;
}(BaseComponent));
export { DocumentCardActionsBase };
//# sourceMappingURL=DocumentCardActions.base.js.map